import { usePointer } from '@vueuse/core'
import { shallowRef, watch } from 'vue'
import { useWebcamRecorder } from './use-webcam-recorder'

export function useWebcamRecorderCanvas () {
  const { canvasRef, webcamTranslate } = useWebcamRecorder()

  const { x, y, pressure } = usePointer({
    target: canvasRef
  })

  const webcamTranslateInitial = shallowRef({ x: 0, y: 0 })
  const pointerInitial = shallowRef({ x: 0, y: 0 })

  watch(pressure, (pressureNew) => {
    if (pressureNew > 0) {
      webcamTranslateInitial.value = webcamTranslate.value
      pointerInitial.value = { x: x.value, y: y.value }
    }
  })

  watch([x, y], ([xNew, yNew]) => {
    if (pressure.value > 0) {
      const deltaX = xNew - pointerInitial.value.x
      const deltaY = yNew - pointerInitial.value.y

      webcamTranslate.value = {
        x: webcamTranslateInitial.value.x + deltaX * 0.4,
        y: webcamTranslateInitial.value.y + deltaY * 0.4
      }
    }
  })
}
